import React from "react"
import SEO from "../shared/seo"
import Layout from "../shared/components/organisms/layout/layout"
import "../shared/styles/index.scss"
import Content from "../components/organisms/content/content"
import { graphql } from "gatsby"

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: false,
      dataSearch: [],
      otherMeta: [
        {
          property: `og:url`,
          content:
            typeof window !== "undefined"
              ? window.location.href
              : "https://d22vncnylxqwjd.cloudfront.net",
        },
        {
          property: `og:image`,
          content: this.props.data.allContentfulNolHomeSegundoNivel.nodes[0]
            .metaImagen.file.url,
        },
      ],
    }
  }

  componentDidMount() {
    const concursesAux = this.props.data.allContentfulNolConcursos.nodes
    var concurses = concursesAux.map(function(el) {
      var o = Object.assign({}, el)
      o.contentType = "nolConcursos"
      return o
    })
    const gamesAux = this.props.data.allContentfulNolJuegos.nodes
    var games = gamesAux.map(function(el) {
      var o = Object.assign({}, el)
      o.contentType = "nolJuegos"
      return o
    })
    const counsultingAux = this.props.data.allContentfulNolConsultorios.nodes
    var counsulting = counsultingAux.map(function(el) {
      var o = Object.assign({}, el)
      o.contentType = "nolConsultorios"
      return o
    })
    const horoscopeAux = this.props.data.allContentfulNolHomeTercerNivel
      .nodes[0].signosDeLosHoroscopos
    var horoscope = horoscopeAux.map(function(el) {
      var o = Object.assign({}, el)
      o.contentType = "nolSignosDelHoroscopo"
      return o
    })
    const productsAux = this.getRestrictedProducts()
    var products = productsAux.map(function(el) {
      var o = Object.assign({}, el)
      o.contentType = "nolProductos"
      return o
    })
    const articlesAux = this.getRestrictedArticles()
    var articles = articlesAux.map(function(el) {
      var o = Object.assign({}, el)
      o.contentType = "articulos"
      return o
    })
    this.setState({
      dataSearch: concurses
        .concat(games)
        .concat(counsulting)
        .concat(horoscope)
        .concat(products)
        .concat(articles),
    })

    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    }
    window.addEventListener("resize", this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    } else {
      this.setState({
        mobile: false,
      })
    }
  }

  getRestrictedProducts = () => {
    let tempItems = []
    this.props.data.allContentfulNolProductos.nodes
      .filter(e => e.metaTitulo !== null)
      .map(item => {
        // console.log((item.paisesDeRestriccionDelArticulo === null || !item.paisesDeRestriccionDelArticulo.includes(process.env.LOCALE.split('-')[1])))
        if (
          item.paisesDeRestriccionDelProducto === null ||
          !item.paisesDeRestriccionDelProducto.includes(
            process.env.LOCALE.split("-")[1]
          )
        ) {
          tempItems.push(item)
        }
        return null
      })
    return tempItems
  }

  getRestrictedArticles = () => {
    return this.props.data.allContentfulNolArticulos.nodes.filter(item => {
      return (
        item.paisesDeRestriccionDelArticulo === null ||
        !item.paisesDeRestriccionDelArticulo.includes(
          process.env.LOCALE.split("-")[1]
        )
      )
    })
  }

  render() {
    return (
      <Layout mobile={this.state.mobile} 
        title={this.props.data.allContentfulNolHomeSegundoNivel.nodes[0].metaTitulo.slice(
          0,
          34
        )}
      >
        <SEO
          title={this.props.data.allContentfulNolHomeSegundoNivel.nodes[0].metaTitulo.slice(
            0,
            34
          )}
          description={this.props.data.allContentfulNolHomeSegundoNivel.nodes[0].metaDescripcion.metaDescripcion.slice(
            0,
            154
          ).split("\n")[0]}
          meta={this.state.otherMeta}
        />
        <Content
          mobile={this.state.mobile}
          dataSearch={this.state.dataSearch}
        />
      </Layout>
    )
  }
}
export const query = graphql`
  query GET_HOME_CONTENT($locale: String!) {
    allContentfulNolHomeSegundoNivel(
      filter: { node_locale: { eq: $locale }, titulo: { eq: "Buscador" } }
    ) {
      nodes {
        metaTitulo
        metaDescripcion {
          metaDescripcion
        }
        metaImagen {
          file {
            url
          }
        }
      }
    }
    allContentfulNolConcursos(
      filter: {
        node_locale: { eq: $locale }
        titulo: { ne: "contenido-oculto" }
      }
    ) {
      nodes {
        estadoConcurso
        titulo
        slug
        redireccionParaParticipar
        metaTitulo
        metaDescripcion {
          metaDescripcion
        }
        metaImagen {
          file {
            url
          }
        }
      }
    }
    allContentfulNolJuegos(filter: { node_locale: { eq: $locale } }) {
      nodes {
        metaImagen {
          file {
            url
          }
          description
        }
        metaDescripcion {
          metaDescripcion
        }
        metaTitulo
        slug
      }
    }
    allContentfulNolConsultorios(filter: { node_locale: { eq: $locale } }) {
      nodes {
        metaImagen {
          file {
            url
          }
          description
        }
        metaDescripcion {
          metaDescripcion
        }
        metaTitulo
        slug
      }
    }
    allContentfulNolHomeTercerNivel(
      filter: { node_locale: { eq: "es-CO" }, titulo: { eq: "Horóscopo" } }
    ) {
      nodes {
        signosDeLosHoroscopos {
          metaImagen {
            file {
              url
            }
            description
          }
          metaDescripcion {
            metaDescripcion
          }
          metaTitulo
          slug
        }
      }
    }
    allContentfulNolProductos(filter: { node_locale: { eq: $locale } }) {
      nodes {
        referenciaSubcategoria {
          categoria
          slug
        }
        metaImagen {
          file {
            url
          }
          description
        }
        metaDescripcion {
          metaDescripcion
        }
        metaTitulo
        slug
        paisesDeRestriccionDelProducto
      }
    }
    allContentfulNolArticulos(filter: { node_locale: { eq: $locale } }) {
      nodes {
        seccionDelArticulo
        paisesDeRestriccionDelArticulo
        segmentoDelArticulo {
          nombreEtiqueta
        }
        metaImagen {
          file {
            url
          }
          description
        }
        metaDescripcion {
          metaDescripcion
        }
        metaTitulo
        slug
      }
    }
  }
`

export default IndexPage
